// extracted by mini-css-extract-plugin
module.exports = {"root":"SportFilterItem_root__FzLP0","text":"SportFilterItem_text__uPCVD","activeText":"SportFilterItem_activeText__8HH_5","icon":"SportFilterItem_icon__aMDqw"};